import { getColor, StyleThemeEnums } from '@gif/shared-global';

const blue600 = getColor('blue600');
const neutral600 = getColor('neutral600');
const white = getColor('white');
const blue700 = getColor('blue700');

export const dark = {
  id: StyleThemeEnums.DARK,
  bgColor: getColor('black'),
  fontColor: getColor('neutral100'),
  linkColor: blue600,
  actionBgColor: blue600,
  iconColor: getColor('neutral200'),
  iconBorderColor: getColor('neutral1400'),
  surface: getColor('neutral1200'),
  legalTextColor: neutral600,
  formFieldInfoMessage: neutral600,
  copyTextBg: getColor('blue700'),
  cardBgColor: getColor('neutral1300'),
};

export const light = {
  id: StyleThemeEnums.LIGHT,
  bgColor: getColor('neutral100'),
  fontColor: getColor('neutral1400'),
  linkColor: blue700,
  actionBgColor: blue700,
  iconColor: getColor('neutral1300'),
  iconBorderColor: getColor('neutral200'),
  surface: white,
  legalTextColor: getColor('neutral900'),
  formFieldInfoMessage: getColor('neutral600'),
  copyTextBg: getColor('blue200'),
  cardBgColor: white,
};
